import axios from '@axios'
import store from "@/store"
import { useUtils as useI18nUtils } from "@core/libs/i18n"

export default {
  namespaced: true,
  state: {
    items: []
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(purge_alarm => ({
        value: purge_alarm.id,
        label: purge_alarm.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { t, tc } = useI18nUtils();

      const response = await axios.get("v1/alarm_purge", {
        params,
        responseType: params?.action == "export" ? "blob" : "json",
      });

      if (!response.data) {
        return [];
      }

      if (params?.action == "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();

        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "alarm-level",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: t('report_of', { model: tc('alarm_purge.title', 1) }),
          body: t('download_succesfully'),
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else {
        commit("setData", response.data.data);
        return response.data;
      }
    },
    async add(_, params) {
      const { data } = await axios.post('v1/alarm_purge', params)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/alarm_purge/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/alarm_purge/${id}`)

      return data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
